import React from 'react'
import { Modal } from '@scuf/common'
import { ModalWrap, ModalTitle } from './device-usage-cpu-modal.styles'
import AssetManagementTable from '../../../../AssetManagementTable'
import PropTypes from 'prop-types'

const columns = [
  { field: 'appName', translation: 'AssetManagementTable_appName', render: ({ value }) => <p>{value}</p> },
  { field: 'cpuUse', translation: 'AssetManagementTable_cpuUse', render: ({ value }) => <p>{value}</p> }
]

const DeviceUsageCpuModal = ({ data, closeModal, t }) => {
  return (
    <ModalWrap>
      <ModalTitle>{t('CpuChart_Total_Title')}</ModalTitle>
      <Modal.Content>
        <AssetManagementTable
          columns={columns}
          data={data}
          disableRowClick={true}
          fileName='Application Usage Time'
          selectionMode='none'
        />
      </Modal.Content>
    </ModalWrap>
  )
}
DeviceUsageCpuModal.defaultProps = {
  closeModal: () => null,
  data: []
}

DeviceUsageCpuModal.propTypes = {
  closeModal: PropTypes.func,
  data: PropTypes.array,
  t: PropTypes.func
}

export default DeviceUsageCpuModal
